import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2, AlertTriangle, ArrowLeft, RefreshCw } from 'lucide-react';

import VistoriaRegiaoMain from './VistoriaRegiaoMain';
import { laudoApi } from '../../services/laudoApi';

/**
 * ============================================================
 * COMPONENTE: NovaVistoria
 * Editor de vistoria embutido no laudo.
 *   Rota: /laudos/:codigo/vistoria
 * VERSÃO: 2.0.0
 * ============================================================
 */

export default function NovaVistoria() {
  const { codigo } = useParams();
  const navigate = useNavigate();

  const [laudo, setLaudo] = useState(null);
  const [infoLaudo, setInfoLaudo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);

  const carregar = async () => {
    if (!codigo) {
      setErro('Código do laudo ausente na URL.');
      setLoading(false);
      return;
    }

    setLoading(true);
    setErro(null);

    try {
      const dados = await laudoApi.carregarLaudo(codigo);
      const payload = dados?.data || dados;
      const laudoCarregado = payload?.laudo || {};

      setLaudo(laudoCarregado);
      setInfoLaudo({
        numero: payload?.reportNumber || payload?.report_id || codigo,
        engenheiro:
          payload?.engenheiro ||
          payload?.perito ||
          laudoCarregado?.perito ||
          'PERITO RESPONSÁVEL',
        titulo: payload?.titulo || `Laudo ${codigo}`,
        endereco: payload?.endereco || null,
      });
    } catch (err) {
      setErro(err.message || 'Falha ao carregar laudo.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { carregar(); }, [codigo]);

  if (loading) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4">
        <Loader2 size={48} className="text-amber-400 animate-spin" />
        <p className="text-[10px] text-slate-500 tracking-[0.5em] font-black italic uppercase">
          CARREGANDO VISTORIA
        </p>
      </div>
    );
  }

  if (erro) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-8">
        <div className="max-w-lg w-full bg-red-950/50 border-2 border-red-500/30 rounded-[3rem] p-10 text-center space-y-6">
          <AlertTriangle size={48} className="text-red-400 mx-auto" />
          <p className="text-red-200 text-[12px] tracking-widest leading-relaxed normal-case">
            {erro}
          </p>
          <div className="flex gap-3 justify-center">
            <button
              type="button"
              onClick={() => navigate(`/laudos/${codigo}/abertura`)}
              className="px-6 py-3 rounded-2xl bg-white/5 border border-white/10 text-white text-[10px] tracking-widest hover:bg-white/10 transition-all flex items-center gap-2"
            >
              <ArrowLeft size={14} /> VOLTAR
            </button>
            <button
              type="button"
              onClick={carregar}
              className="px-6 py-3 rounded-2xl bg-amber-400 text-slate-950 text-[10px] tracking-widest hover:bg-white transition-all flex items-center gap-2"
            >
              <RefreshCw size={14} /> TENTAR NOVAMENTE
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <VistoriaRegiaoMain
      infoLaudo={infoLaudo}
      peritoAtivo={infoLaudo.engenheiro}
      laudoInicial={laudo}
      onProtocolo={({ hashDigital }) => {
        console.info('[Vistoria] Protocolo selado', { hashDigital });
        navigate(`/laudos/${codigo}/analise`);
      }}
    />
  );
}